import React from "react";
import FormElement from "../form-element";

export default function Group(props) {
  const { element = {}, checkContentRequirements } = props;
  const { content = [], text = "" } = element;

  function getContent() {
    return checkContentRequirements(content);
  }

  return (
    <div className="form-group">
        <div className="col form-elements">
          {getContent().map(c => (
            <FormElement element={c} key={c.id} />
          ))}
      </div>
    </div>
  );
}
